/*
 * 便利関数
 */
export default function (Vue) {
  Vue.util = Vue.util || {}

  /**
   * ロック対象のサブミットボタン一時保管用
   * @type {Array}
   */
  Vue.util.lockButtons = []

  /**
   * サブミットボタンをロックする
   * @param config
   */
  Vue.util.lockSubmitButtons = function (config) {
    if (!config) {
      return
    }
    const method = config.method.toLowerCase()
    if (method === 'post' || method === 'put' || method === 'delete') {
      const buttons = document.querySelectorAll('button[type="submit"]')
      for (let button of buttons) {
        // 元々disabledのボタンは対象外とする
        if (!button.disabled) {
          button.disabled = true
        }
      }
      Vue.util.lockButtons = buttons
    }
  }

  /**
   * サブミットボタンのロックを解除する
   * @param response
   */
  Vue.util.unlockSubmitButtons = function (response) {
    if (!response || !response.config) {
      return
    }
    const method = response.config.method.toLowerCase()
    if (method === 'post' || method === 'put' || method === 'delete') {
      const buttons = Vue.util.lockButtons
      for (let button of buttons) {
        button.disabled = false
      }
      Vue.util.lockButtons = []
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/Utils.js